import * as styles from './styles/styles.module.scss';
import EmployeeCollage from './EmployeeCollage';

const appStoreEditorsChoiceIcon = require('../../../../assets/images/icons/careers/appstore-editorschoice.svg');
const playStoreEditorsChoiceIcon = require('../../../../assets/images/icons/careers/playstore-editorschoice.svg');

const AboutCareers = (): JSX.Element => (
  <div className={styles.container}>
    <div className={styles.content}>
      <h2 className={styles.headerText}>Calling all nature lovers</h2>
      <div className={styles.mainText}>
        We’re out here inspiring people worldwide to enjoy the outdoors. And as a remote-friendly company, our team is distributed too. Just like the
        trails we love, we’re in the mountains, in deserts, on waterfronts, and in cities big and small. And what brings us together is our love for
        the trail. Come join us.
      </div>
      <div className={styles.editorsChoiceContainer}>
        <a href="https://alltrails.io/ujRkr9MGmgb" target="_blank" rel="noreferrer">
          <img src={appStoreEditorsChoiceIcon} alt="App store editor's choice" loading="lazy" className={styles.appStoreIcon} />
        </a>
        <a href="https://alltrails.io/pW7o6i6Lmgb" target="_blank" rel="noreferrer">
          <img src={playStoreEditorsChoiceIcon} alt="Play store editor's choice" loading="lazy" className={styles.appStoreIcon} />
        </a>
      </div>
    </div>
    <EmployeeCollage />
  </div>
);

export default AboutCareers;
